import { waitForGtag, waitForHeap } from '@/lib/tracking-utils'

const SfcTrackingService = {
	trackCtaClick({
		eventName,
		page,
		plan,
		contextPlacement = 'none',
		clickSource,
		elementIndex,
		designVersion
	}) {
		const data = {
			page,
			plan_id: plan.id,
			plan_name: plan.name,
			plan_state: plan.state_object.name,
			context_placement: contextPlacement,
			click_source: clickSource,
			event_name: eventName,
			plan_type: plan.has_enroll_now ? 'participant' : 'non-participant',
			element_index: elementIndex,
			design_version: designVersion
		}

		localStorage.setItem(eventName, JSON.stringify(data))

		gtag('event', eventName, data)
		heap.track(eventName, data)
	},
	trackEnrollNowClick(properties) {
		const { page, designVersion } = properties

		this.trackCtaClick({
			...properties,
			eventName: 'enroll_now_clicked',
			designVersion: designVersion || 'old_cta'
		})

		gtag('event', 'Click - Enroll Now Button', page)
	},

	trackTrialEnrollNowClick(page, plan_name = '') {
		gtag('event', 'Click - Trial Enroll Now', {
			page: page,
			plan_name: String(plan_name)
		})
	},

	trackPlanDetailsClick(properties) {
		this.trackCtaClick({
			...properties,
			eventName: 'plan_details_clicked',
			designVersion: properties.designVersion || 'text_link'
		})
	},

	trackLearnMoreClick(page, version, plan_name = false) {
		gtag('event', 'Click - Learn More', {
			page: page,
			plan_name: plan_name,
			version: version
		})
	},

	trackInvestmentOptionsClick(page, version, plan_name) {
		gtag('event', 'Click - Investment Options', {
			page: page,
			plan_name: plan_name,
			version: version
		})
	},

	trackFindAProClick(properties) {
		const { page, designVersion, version, plan_name } = properties

		this.trackCtaClick({
			...properties,
			eventName: 'find_a_pro_clicked',
			designVersion: designVersion || 'old_cta'
		})

		gtag('event', 'Click - Find a Pro', {
			page,
			plan_name,
			version
		})
	},

	trackPageShown({ webPage, pageType }) {
		const data = {
			web_page: webPage,
			page_type: pageType
		}
		const eventName = 'page_shown'

		waitForGtag()
			.then(() => {
				gtag('event', eventName, data)
			})
			.catch(error => {
				console.error('Error loading gtag:', error)
			})

		waitForHeap()
			.then(() => {
				heap.track(eventName, data)
			})
			.catch(error => {
				console.error('Error loading heap:', error)
			})
	},

	trackCategoryClick(page, version, category_name, section, article_title = false, state = false) {
		gtag('event', 'Click - Best Plans Category', {
			page: page,
			version: version
		})
	},

	trackShare(page, version, platform, article_title = false) {
		gtag('event', 'Share -' + platform, {
			page: page,
			version: version
		})
	},

	trackSubscribeAdvisorCTAClick(page, version, article_title) {
		gtag('event', 'Click - Subscribe Advisor CTA', {
			page: page,
			version: version
		})
	},

	trackPaginationClick(page, version, article_title, page_number) {
		gtag('event', 'Click - Article Pagination', {
			page: page,
			version: version
		})
	},

	trackBasicsClick(page, version, category) {
		gtag('event', 'Click - College Savings Basics', {
			page: page,
			version: version
		})
	},

	trackTaxBenefitsClick(page, version, plan_name) {
		gtag('event', 'Click - Tax Benefits', {
			page: page,
			version: version
		})
	},

	trackCalculatorInteraction(page, version, part) {
		gtag('event', 'Calculator Interaction', {
			page: page,
			version: version
		})
	},

	trackCollegeBackerClick(page, version) {
		gtag('event', 'Click - CollegeBacker', {
			page: page,
			version: version
		})
	},

	trackSubscriptionPageLoad(companyName = null) {
		if (companyName && companyName == 'xypn') {
			gtag('event', 'Page Load - XYPN Subscription', {
				page: window.location.href
			})
		}
		if (companyName && companyName == 'capstone') {
			gtag('event', 'Page Load - Capstone Subscription', {
				page: window.location.href
			})
		}
		if (!companyName) {
			gtag('event', 'Page Load - Subscription Page', {
				page: window.location.href
			})
		}
	},

	trackSubscribePage(eventLabel, eventValue) {
		gtag('event', 'Signup - Premium Subscriptions', {
			label: eventLabel,
			value: eventValue
		})
	},

	trackSubscribeXYPNPage(eventLabel, eventValue) {
		gtag('event', 'Signup - XYPN Premium Subscriptions', {
			label: eventLabel,
			value: eventValue
		})
	},

	trackSubscribeCapstonePage(eventLabel, eventValue) {
		gtag('event', 'Signup - Capstone Premium Subscriptions', {
			label: eventLabel,
			value: eventValue
		})
	},

	trackDownloadPlanDetailsReport() {
		gtag('event', 'Download - Plan Summary Report', {
			page: window.location.href
		})
	},

	trackCollegeBackerEvent(eventName, page, version, planName) {
		gtag('event', eventName, {
			page: page,
			version: version
		})
	},

	trackAction(eventDescription, page, version) {
		const sendGtagEvent = () => {
			gtag('event', eventDescription, {
				page: page,
				version: version
			})
		
		}
		
		if (typeof gtag !== 'undefined') {
			sendGtagEvent()
		} else {
			waitForGtag()
				.then(() => {
					sendGtagEvent()
				})
				.catch(error => {
					console.error('Error loading gtag:', error)
				})
		}
	},

	trackAnalyticsAction(category, action, label) {
		const sendGtagEvent = () => {
			gtag('event', category, {
				action: action,
				label: label
			})
		}
		if (typeof gtag !== 'undefined') {
			sendGtagEvent()
		} else {
			waitForGtag()
				.then(() => {
					sendGtagEvent()
				})
				.catch(error => {
					console.error('Error loading gtag:', error)
				})
		}
	},

	trackStateTaxBenefitsCalloutClick() {
		gtag('event', 'Click - State Tax Benefits Callout', {
			page: window.location.href
		})
	}
}

export default SfcTrackingService
